import request from '@/utils/request'

export function getUPGrpList(param) {
  let data = param
  return request({
    url: `/quotation/epms7050/getUPGrpList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}